'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _scrollSmooth = require('./scrollSmooth');

var _scrollSmooth2 = _interopRequireDefault(_scrollSmooth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '[href^="#"]:not([href="#"]';
  var config = arguments[1];

  var links = document.querySelectorAll(query);

  Array.from(links).map(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      var dest = document.getElementById(e.target.hash.substring(1));
      if (!dest) return;
      (0, _scrollSmooth2.default)(dest, _extends({}, config));
    }, false);
  });
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/scroll-smooth/dist/anchorScroll.js
// module id = 1974
// module chunks = 0